import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "left-area" }
const _hoisted_3 = { class: "right-area" }
const _hoisted_4 = {
  key: 0,
  class: "header-notice"
}
const _hoisted_5 = { class: "outer-container" }
const _hoisted_6 = { class: "scroll-wrapper" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "icon-wrapper" }
const _hoisted_10 = { class: "right-item username" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "search-results"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Bell = _resolveComponent("Bell")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_BindWxDialog = _resolveComponent("BindWxDialog")!
  const _component_BindPhoneDialog = _resolveComponent("BindPhoneDialog")!
  const _component_NoticeDialog = _resolveComponent("NoticeDialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toBack()))
        }, "返回"),
        _createElementVNode("div", {
          class: _normalizeClass(['hamburger-container', _ctx.sidebar.opened ? '' : 'rotate180']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSideBar && _ctx.toggleSideBar(...args)))
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Fold)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: "search-container",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSearchDialog && _ctx.openSearchDialog(...args)))
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Search)
            ]),
            _: 1
          })
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "center-area" }, [
        _createElementVNode("img", {
          src: "https://image-oss.dangaoss.cn/common/common_20241121140957_437.png",
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.UserType[_ctx.userInfo.user_type] === '合作商户' && _ctx.warningLength.instationMsgWarn > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NoticeList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "scroll-data-container",
                      onClick: ($event: any) => (_ctx.clickRowNotice(item))
                    }, _toDisplayString(item.title) + _toDisplayString(item.type === 2 ? item.course_type == 1 ?' - 视频' :' - 文档':''), 9, _hoisted_7))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NoticeList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index + '_copy',
                      class: "scroll-data-container",
                      onClick: ($event: any) => (_ctx.clickRowNotice(item))
                    }, _toDisplayString(item.title) + _toDisplayString(item.type === 2 ? item.course_type == 1 ?' - 视频' :' - 文档':''), 9, _hoisted_8))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_badge, {
                  value: _ctx.warningLength.instationMsgWarn,
                  class: "item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      class: "horn",
                      size: "25"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Bell, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleHornClick()))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userInfo.username), 1),
        _createVNode(_component_el_dropdown, { trigger: "click" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_ctx.UserType[_ctx.userInfo.user_type] === '合作商户')
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      onClick: _ctx.onBindWx
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("绑定微信")
                      ])),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.jumpToEditPassword }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("修改密码")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.logout }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("退出")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "avatar",
              src: require('@/assets/imgs/logo.png')
            }, null, 8, _hoisted_11)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_BindWxDialog, { ref: "bindWxDialog" }, null, 512),
    _createVNode(_component_BindPhoneDialog, {
      ref: "bindPhoneDialog",
      showClose: false
    }, null, 512),
    _createVNode(_component_NoticeDialog, { ref: "noticeDialog" }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.searchDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchDialogVisible) = $event)),
      title: "搜索导航",
      width: "400px",
      "close-on-click-modal": false,
      onOpen: _ctx.onSearchDialogOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          id: "search-nav-input",
          modelValue: _ctx.searchQuery,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQuery) = $event)),
          placeholder: "输入导航名称搜索",
          clearable: "",
          onInput: _ctx.handleSearch,
          onKeyup: _withKeys(_ctx.handleSearch, ["enter"]),
          "prefix-icon": "el-icon-search"
        }, null, 8, ["modelValue", "onInput", "onKeyup"]),
        (_ctx.searchResults.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: result.path,
                  class: "search-result-item",
                  onClick: ($event: any) => (_ctx.handleSearchResultClick(result))
                }, _toDisplayString(result.title), 9, _hoisted_13))
              }), 128))
            ]))
          : (_ctx.searchQuery)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 未找到相关页面 "))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onOpen"])
  ], 64))
}